import React from "react";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const StyledUl = styled("ul")(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  listStyleType: "disc",
  "& li": {
    marginBottom: theme.spacing(1),
  },
}));

function InformationProtection() {
  return (
    <MDBox p={3}>
      <MDTypography variant="h4" fontWeight="medium" mb={2} color="info">
        Kişisel Verilerin Korunması Kanunu Aydınlatma Metni
      </MDTypography>

      {/* Veri Sorumlusu */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        Veri Sorumlusu
      </MDTypography>
      <MDTypography variant="body2" color="text">LogicaDx Bilişim Danışmanlık</MDTypography>
      <MDTypography variant="body2" color="text">Adres: Barbaros Mah. Ihlamur Blv. No: 3, İç Kapı No: 15, Ataşehir / İstanbul</MDTypography>
      <MDTypography variant="body2" color="text">Vergi Kimlik Numarası: 7960516854</MDTypography>
      <MDTypography variant="body2" color="text" mb={2}>E-posta: info@logicookie.com — Web: www.logicookie.com</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 1. Amaç ve Kapsam */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        1. Amaç ve Kapsam
      </MDTypography>
      <MDTypography variant="body2" color="text">
        İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;) uyarınca, LogicaDx tarafından işletilen LogiCookie yazılımını kullanan ziyaretçi, müşteri ve kullanıcıların kişisel verilerinin işlenmesine ilişkin usul ve esasları açıklamak amacıyla hazırlanmıştır.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 2. İşlenen Kişisel Veri Kategorileri */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        2. İşlenen Kişisel Veri Kategorileri
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text"><strong>Kimlik Bilgileri:</strong> Ad, soyad, unvan.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>İletişim Bilgileri:</strong> E-posta adresi, telefon numarası, IP adresi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Müşteri/Üye İşlem Bilgileri:</strong> Abonelik planı, işlem geçmişi, destek talepleri.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Finansal/Faturalama Bilgileri:</strong> Fatura adı/unvanı, vergi bilgileri, ödeme kayıtları. (Kredi/banka kartı verileri LogiCookie tarafından tutulmaz; ödeme kuruluşu altyapısında işlenir.)</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Hizmet Kullanım Bilgileri:</strong> Oturum/log kayıtları, çerez tercihleri ve rıza kayıtları, cihaz/tarayıcı bilgileri.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Hukuki Uyum Bilgileri:</strong> Tebligat/yazışma kayıtları, resmi makam taleplerine verilen yanıtlar.</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 3. Kişisel Verilerin İşlenme Amaçları */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        3. Kişisel Verilerin İşlenme Amaçları
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text">Platformun sunulması, sözleşmenin kurulması ve ifası, hesap oluşturma ve abonelik yönetimi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Ödeme ve faturalama süreçlerinin yürütülmesi, tahsilat ve mutabakat işlemleri.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Çerez tercih ve rıza kayıtlarının saklanması, raporlanması ve denetlenebilirliğinin sağlanması.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Destek/şikâyet yönetimi ve teknik operasyonların yürütülmesi; güvenlik, hata/performans takibi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Mevzuattan kaynaklanan yükümlülüklerin yerine getirilmesi ve resmi makamlara bilgi verilmesi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Meşru menfaat kapsamında ürün geliştirme, kullanım analizi ve hizmet kalitesinin iyileştirilmesi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Pazarlama/iletişim: Açık rızanız mevcutsa yeni özellikler, kampanyalar ve bültenlere ilişkin ticari elektronik iletilerin gönderilmesi.</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 4. Toplama Yöntemi ve Hukuki Sebepler */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        4. Toplama Yöntemi ve Hukuki Sebepler
      </MDTypography>
      <MDTypography variant="body2" color="text" gutterBottom>
        Kişisel verileriniz; internet sitemiz (logicookie.com), uygulama panelleri, çerez yönetim modülleri, destek/iletişim kanalları ve sözleşme/teklif süreçleri üzerinden elektronik ortamda toplanır ve aşağıdaki hukuki sebeplerle işlenir:
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text"><strong>KVKK m.5/2(c):</strong> Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>KVKK m.5/2(ç):</strong> Veri sorumlusunun hukuki yükümlülüğünü yerine getirmesi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>KVKK m.5/2(f):</strong> İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla meşru menfaatlerimizin gerektirmesi.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>KVKK m.5/1:</strong> Açık rıza (ör. ticari elektronik ileti ve belirli pazarlama faaliyetleri).</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 5. Çerezler ve Benzeri Teknolojiler */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        5. Çerezler ve Benzeri Teknolojiler
      </MDTypography>
      <MDTypography variant="body2" color="text">
        Sitede zorunlu çerezler temel işlevler için kullanılır. Tercih/istatistik/pazarlama çerezleri ise yalnızca açık rızanızla çalışır. Detaylar için Çerez Politikamızı inceleyebilirsiniz. (Rıza vermemek hizmetin temel fonksiyonlarını etkilemez.)
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 6. Kişisel Verilerin Aktarılması */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        6. Kişisel Verilerin Aktarılması
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text">Hizmet sağlayıcılar: Barındırma, bulut, güvenlik, loglama, e-posta ve ödeme kuruluşları.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Finans ve muhasebe: Bankalar, mali müşavir ve gerektiğinde bağımsız denetçiler.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Yasal zorunluluk halinde: İlgili kamu kurum ve kuruluşları ile yargı mercileri.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Uyuşmazlık/denetim: Avukatlar, arabulucular ve mevzuata uygun diğer uzmanlar.</MDTypography></li>
      </StyledUl>
      <MDTypography variant="body2" color="text">
        Yurt dışına aktarım söz konusu olduğunda (ör. bulut hizmetleri) KVKK’nın 9. maddesi uyarınca Kurul kararları ve geçerli aktarım mekanizmaları (yeterlilik kararı, taahhütler, sözleşmesel güvenceler vb.) esas alınır; gerekli durumlarda açık rızanız temin edilir.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 7. Saklama Süreleri */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        7. Saklama Süreleri
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text">Hesap/abonelik verileri: İlişki devam ettiği sürece; sonlandırmadan sonra ilgili mevzuattaki zamanaşımı ve saklama süreleri kadar.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Faturalama ve mali kayıtlar: 10 yıl (TTK ve VUK).</MDTypography></li>
        <li><MDTypography variant="body2" color="text">5651 trafik kayıtları/loglar: En az 2 yıl.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Rıza ve tercih kayıtları: İlgili kapsamda ispat yükümlülüğü süresince.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Hesap silme talebi: Hesap silindiğinde çerez tercih kayıtları dâhil ilgili veriler derhal ve kalıcı olarak silinir; kanuni saklama süreleri saklıdır.</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 8. İlgili Kişinin Hakları (KVKK m.11) */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        8. İlgili Kişinin Hakları (KVKK m.11)
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text">Kişisel verilerin işlenip işlenmediğini öğrenme ve bilgi talep etme,</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Amaca uygun kullanılıp kullanılmadığını öğrenme ve yurt içi/yurt dışı aktarımları bilme,</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Eksik/yanlış işlenmişse düzeltilmesini isteme; şartları varsa silinmesini/yok edilmesini talep etme,</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Yapılan işlemlerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Otomatik sistemlerce analiz sonucunda aleyhe bir durum doğmasına itiraz etme,</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Kanuna aykırı işleme nedeniyle zararın giderilmesini talep etme.</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 9. Başvuru Usulü */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        9. Başvuru Usulü
      </MDTypography>
      <MDTypography variant="body2" color="text">
        KVKK m.13 kapsamında haklarınıza ilişkin taleplerinizi; yazılı olarak adresimize, KEP üzerinden veya info@logicookie.com adresine iletebilirsiniz. Başvurular en geç 30 gün içinde sonuçlandırılır.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 10. Ticari Elektronik İletiler */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        10. Ticari Elektronik İletiler
      </MDTypography>
      <MDTypography variant="body2" color="text">
        E-posta/SMS ile tanıtım, kampanya ve bülten gönderimleri yalnızca açık rızanız veya İYS onayınız varsa yapılır. Onayı dilediğiniz zaman ücretsiz olarak geri çekebilirsiniz.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 11. Güvenlik ve Teknik/İdari Tedbirler */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        11. Güvenlik ve Teknik/İdari Tedbirler
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text">Şifreleme, erişim yetkilendirme, ağ güvenliği, yedekleme ve loglama süreçleri uygulanır.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Ödeme verileri PCI-DSS uyumlu ödeme kuruluşları üzerinden işlenir; kart verileri tarafımızca saklanmaz.</MDTypography></li>
        <li><MDTypography variant="body2" color="text">Yetkisiz erişim, kayıp veya ifşa risklerine karşı düzenli denetim ve testler yapılır; ihlal halinde Kurul ve ilgili kişilere bildirim yapılır.</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      <MDTypography variant="caption" color="text.secondary">
        Son Güncelleme: 18.08.2025
      </MDTypography>
    </MDBox>
  );
}

export default InformationProtection;
